import { render, staticRenderFns } from "./pay_doc.vue?vue&type=template&id=e9ef167a&scoped=true"
import script from "./pay_doc.vue?vue&type=script&lang=js"
export * from "./pay_doc.vue?vue&type=script&lang=js"
import style0 from "./pay_doc.vue?vue&type=style&index=0&id=e9ef167a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ef167a",
  null
  
)

export default component.exports